import Link from 'next/link'
import { ChevronRight, Home } from 'lucide-react'

interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

const BASE_URL = process.env.NEXT_PUBLIC_APP_URL || 'https://chatbotty.ai'

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  // JSON-LD for BreadcrumbList schema
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.href && { item: `${BASE_URL}${item.href}` }),
    })),
  }

  return (
    <>
      <nav aria-label="Breadcrumb" className="mb-6">
        <ol className="flex items-center flex-wrap gap-1.5 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index === 0 && (
                <Home className="mr-1.5 h-3.5 w-3.5 text-muted-foreground/70" />
              )}
              {index > 0 && (
                <ChevronRight className="mx-1.5 h-3.5 w-3.5 text-muted-foreground/40" />
              )}
              {item.href ? (
                <Link
                  href={item.href}
                  className="font-medium text-muted-foreground transition-colors duration-200 hover:text-indigo-600 dark:hover:text-indigo-400"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="font-medium text-foreground">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  )
}
